import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";
@Component({
  selector: "app-crudmessagelist",
  templateUrl: "./crudmessagelist.component.html",
  styleUrls: ["./crudmessagelist.component.scss"]
})
export class CrudmessagelistComponent implements OnInit {
  isLoading = false;
  isError = false;
  errorMessage = "";
  tabs = [];
  mode = "";
  id = "";
  name = "";
  objectId = "";
  objectName = "";
  // displayedColumns: string[] = ["label", "name"];

  // dataSource: any[] = [];

  displayedColumns: string[] = [
    "action",
    "message",
    "operation",
    "language",
    "type"
  ];
  dataSource = "";
  matchingrule: any;
  crudmessages: any;

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }
  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.getCrudMessage();
  }

  cancel() {
    this.router.navigateByUrl("/home");
  }
  new() {
    this.router.navigateByUrl("/home/crudmessage/new");
  }

  getCrudMessage() {
    return new Promise((resolve, reject) => {
      console.log("getcrudmessages");

      // alert(id)
      const organizationid = localStorage.getItem("crm_orgid");
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService
        .getCrudMessage(domain, subdomain, organizationid)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.crudmessages = res.data.crudmessage;
              console.log("Doneeee****", this.crudmessages);

              if (this.crudmessages != null) {
                this.dataSource = this.crudmessages.map((item) => ({
                  id: item.id,
                  // label: item.labelname,

                  message: item.message,
                  operation:
                    item.operation.charAt(0).toUpperCase() +
                    item.operation.slice(1),
                  language: item.languagecode,
                  // modifiedby: item.modifiedby,
                  // modifieddate: item.modifieddate,

                  // type: item.organizationid,
                  // type: item.organizationid ? item.organizationid : 'common',
                  type: item.organizationid ? "Tenant" : "Common"

                  // content: item.content,
                  // metalayoutid: item.metalayoutid,
                }));
              }

              this.isLoading = false;
            } else {
              console.log("Error while saving");
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }

  editApp(element: any) {
    this.router.navigateByUrl("/home/crudmessage/edit/" + element.id);
  }

  delete(id: any, type: any) {
    // alert(id)
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }
    this.isLoading = true;
    this.dataService.deleteCrudMessage(id, type, domain, subdomain).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // alert("Are you sure?")

          this.showSuccess(res.message);
          this.isLoading = false;

          window.location.reload();
        } else {
          console.log("Failed to delete!");
          this.isLoading = false;
          this.showError(res.message);
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        this.showError(err.message);
      }
    );
  }
}
